<div red-group [attr.state]="state" [attr.size]="size">
    <ng-content></ng-content>
</div>
